<div fxFlex="0 0 100%" fxLayout="row wrap" class="section-user-select sticky-title-wrapper">
    <app-sticky-header
        class="sticky-header"
        title="Specify route"
        i18n-title
        (onSubmit)="submit()"
        (onCancel)="bottomSheetRef.dismiss()"
    ></app-sticky-header>
    <div *ngIf="data" class="w-100 mt-1">
        <mat-tab-group class="user-manage-cp-access" fxFlex="0 0 100%" ngClass.xs="xs">
            <mat-tab [label]="AppScope.USERS | modelDynamicLabel | async">
                <ng-template matTabContent>
                    <app-admin-users-select
                        [customer_id]="data.customer.id"
                        referenceFilter="referenceCustomerRoute"
                        [canSelectAll]="false"
                        [accessForm]="assignForm"
                        [referencePropertyValue]="data.customer.id + '|' + assignForm.value.route"
                    ></app-admin-users-select>
                </ng-template>
            </mat-tab>
            <mat-tab [label]="AppScope.GROUPS | modelDynamicLabel | async">
                <ng-template matTabContent>
                    <app-admin-groups-select
                        [customer_id]="data.customer.id"
                        referenceFilter="referenceCustomerRoute"
                        [isTeam]="data.customer.division_mode"
                        [canSelectAll]="false"
                        [columns]="['select', 'name', 'users_count', 'created_at', 'updated_at']"
                        [referencePropertyValue]="data.customer.id + '|' + assignForm.value.route"
                        [accessForm]="assignForm"
                    ></app-admin-groups-select>
                </ng-template>
            </mat-tab>
            <mat-tab
                *ngIf="data.customer.division_mode && data.authUser.hasRoleHigherThan('groupadmin')"
                [label]="AppScope.TEAM | modelDynamicLabel | async"
            >
                <ng-template matTabContent>
                    <app-admin-groups-select
                        [customer_id]="data.customer.id"
                        referenceFilter="referenceCustomerRoute"
                        [accessForm]="assignForm"
                        [canSelectAll]="false"
                        [filtersToBeApplied]="[{ property: 'team', items: [1] }]"
                        [referencePropertyValue]="data.customer.id + '|' + assignForm.value.route"
                        sync_all_key="sync_all_teams"
                        attachKey="teams_attach"
                        detachKey="teams_detach"
                    ></app-admin-groups-select>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
